import {Customization, css} from '@eduvision/toolkit';

export const Footer: Customization['Footer'] = {
  staticOverViewLinks: [],
  proLinks: [],
  termsOfServiceLinks:[
    {
      name: 'Nutzungsbedingungen',
      path: '/terms'
    },
    {
    name: 'Datenschutzbestimmungen',
    path: '/data-privacy',
  },
  {
    name: 'Impressum',
    path: 'https://www.charta-der-vielfalt.de/impressum',
    isExternal: true
  },
  {
    name: 'Lizenzhinweise',
    path: '/licenses'
  }],
  showProductSection: false
};
